// Top-level routing for the klonit-admin SPA.
//
//   /login                       -> public Login page
//   /users           (auth)      -> Users list
//   /users/:userId   (auth)      -> User detail (subscription + invoices + Pay)
//   /invoices/pending (auth)     -> Pending invoices across all users
//   /                (auth)      -> redirect to /users
//   *                            -> redirect to /users (or /login via the guard)
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import RequireAuth from './components/RequireAuth';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import PendingInvoices from './pages/PendingInvoices';

const App = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<RequireAuth><AppShell /></RequireAuth>}>
                <Route path="/" element={<Navigate to="/users" replace />} />
                <Route path="/users" element={<Users />} />
                <Route path="/users/:userId" element={<UserDetail />} />
                <Route path="/invoices/pending" element={<PendingInvoices />} />
                <Route path="*" element={<Navigate to="/users" replace />} />
            </Route>
        </Routes>
    </BrowserRouter>
);

export default App;
